<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get } from 'lodash';
import logo from '@/assets/plans/logo_zoom_email_calendar.svg';

export default {
  name: 'ZoomEmailCalendarAddon',
  mixins: [base],
  for: () => {
    return false;
  },
  data() {
    return {
      logo,
      title: this.$t('billing.zoom_email_calendar.title'),
      planType: planTypes.ZOOM_EMAIL_CALENDAR,
      description: this.$t('billing.zoom_email_calendar.desc'),
    }
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return this.planMapFlat.filter((p) => p.type === planTypes.ZOOM_EMAIL_CALENDAR);
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
